import { fi, type Texts } from './fi.js';

// Only Finnish in the first version.
export const t: Texts = fi;
